import * as React from 'react';
import { User } from '../../../core';
import { AvatarImage } from '../../../components/render-file/AvatarImage';

const UserList: React.FunctionComponent<{ users: User[] }> = (props) => {
  return (
    <ul className="list-unstyled mb-0">
      {props.users?.map((user, index) => {
        return (
          <li
            key={index}
            className="border-bottom py-2 d-flex align-items-center cursor-pointer"
          >
            <div className="mr-2">
              <div className="avatar-progress avatar-progress--xs position-relative cursor-pointer">
                <svg>
                  <circle r="12" cx="50%" cy="50%" className="default"></circle>
                  <circle
                    r="12"
                    cx="50%"
                    cy="50%"
                    className="progress"
                    stroke-dasharray="117"
                    stroke-dashoffset="75"
                  ></circle>
                </svg>
                <AvatarImage
                  image={user.avatar}
                  className="position-absolute left-0 right-0 top-0 bottom-0 m-auto rounded-circle"
                ></AvatarImage>
              </div>
            </div>
            <div className="py-1">
              <h6 className="mb-0">{user.name}</h6>
              <p className="mb-0 font-xs text-gray-600">{user.accountType}</p>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default UserList;
